import React from 'react';
import { Modal, Button, Table, Tooltip, Upload, message } from 'antd';
import FileStep from '../../../../components/FileStep';
import { downloadFile } from '../../../../utils/index';
import { getTemplateByImportExpress, importExpressFile, getImportingExpressStatus } from '../../../../service/expressMaterial';
import './style.scss';


const columns = [
  {
    title: '行数',
    dataIndex: 'line',
    width: 50,
    fixed: 'left'
  },
  {
    title: '受理号',
    dataIndex: 'flowId',
    width: 140
  },
  {
    title: '邮寄时间',
    dataIndex: 'expressTime',
    width: 140
  },
  {
    title: '快递公司',
    dataIndex: 'expressCompany',
    width: 130
  },
  {
    title: '运单号',
    dataIndex: 'expressNumber',
    width: 130
  },
  {
    title: '备注',
    dataIndex: 'remark',
    render: text => <Tooltip placement="top" title={text}><p className="row-ellipsis">{text}</p></Tooltip>
  },
  {
    title: '错误原因',
    dataIndex: 'errorMsg',
    fixed: 'right',
    with: 150,
    render: text => <p style={{ color: '#FF1414' }}>{text}</p>
  },
];

const uploadProps = {
  multiple: false,
  accept: '.xls,.xlsx,.csv',
  showUploadList: false,
  beforeUpload(file) {
    const fileType = file.name.split('.').pop();
    const isFile = ['xls', 'xlsx', 'csv'].includes(fileType);
    if (!isFile) {
      message.error('导入文件，支持xls、xlsx、csv');
      return false;
    }
    return isFile;
  }
}

export default class ImportExpressPackages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // 1上传、解析文件，2文件解析错误，3解析成功，上传
      step: 1,
      isUploading: false,
      errorList: [],
      // 1正在导入，3导入成功
      importStatus: ''
    }
  }

  // 取消弹框
  handleCancel = () => {
    this.props.onCancel && this.props.onCancel();
    this.setState({
      step: 1,
      errorList: [],
      importStatus: '',
      isUploading: false
    })
  }

  getTitle = () => {
    const { step } = this.state;
    switch (step) {
      case 2:
        return '错误数据如下';
      default:
        return '导入寄出包裹'
    }
  }

  getImportingStatus = () => {
    getImportingExpressStatus().then(({ result }) => {
      switch (result.uploadStatus) {
        // 正在导入，继续轮询
        case 1:
          this.getImportingStatus();
          break;
        // 导入成功，隐藏正在导入弹框，显示导入成功弹框
        case 3:
          this.setState({
            step: 3,
            importStatus: result.uploadStatus
          })
          break;
        default:
          this.setState({
            step: 1,
            importStatus: ''
          })
          message.error('导入失败');
      }
    })
  }
  // 下载文件示例
  downloadTemplate = async () => {
    try {
      const { result } = await getTemplateByImportExpress();
      downloadFile(result.fileUrl);
    } catch { }
  }

  handleUpload = async ({ file }) => {
    try {
      const formData = new FormData();// 创建form对象
      formData.append('file', file);
      this.setState({
        isUploading: true
      })
      const { result } = await importExpressFile(formData, { 'Content-Type': 'multipart/form-data' });
      // 解析成功，进行导入校验流程；解析失败，展示错误数据列表
      if (result.state) {
        this.setState({
          step: 3,
          importStatus: 1
        })
        this.getImportingStatus();
        // this.props.onCancel && this.props.onCancel();
      } else {
        this.setState({
          step: 2,
          errorList: result.errorList
        })
      }
    } catch {}
    this.setState({
      isUploading: false
    })
  }

  render() {
    const { step, isUploading, errorList, importStatus } = this.state, { visible } = this.props;
    return <React.Fragment>
      <Modal
        title={this.getTitle()}
        visible={visible}
        footer={null}
        onCancel={this.handleCancel}
        width={700}
        destroyOnClose
        maskClosable={false}
        bodyStyle={{ padding: '20px 40px' }}
      >
        {/* 导入文件弹框 */}
        {
          step === 1 ? <FileStep content={[
            ["第一步：下载导入寄出包裹的模板文件", <Button type="primary" size="small" onClick={this.downloadTemplate}>下载模板</Button>],
            ['第二步：将案件运单信息整理到下载好的模板文件（必须严格按照模板）'],
            ['第三步：将整理好的文件上传导入', <React.Fragment>
              {
                isUploading ? <Button type="primary" size="small" loading>解析中</Button> : <Upload {...uploadProps} customRequest={this.handleUpload}>
                  <Button type="primary" size="small">导入文件</Button>
                </Upload>
              }
            </React.Fragment>]]} /> : null
        }
        {/* 错误列表展示 */}
        {
          step === 2 ? <React.Fragment>
            <Table bordered columns={columns} dataSource={errorList} size="small" pagination={false} scroll={{ x: 1000, y: 300 }} />
            <div className="align-right" style={{ marginTop: 15 }}><Button type="primary" size="small" onClick={() => this.setState({ step: 1 })}>重新操作</Button></div>
          </React.Fragment> : null
        }
        {/* 导入结果弹框 */}
        {
          step === 3 ? <div className="import-notification">
            {
              importStatus === 1 ? <React.Fragment>
                <i className="iconfont icon-rotate-loading" />
                <h3>正在导入</h3>
                <p>请勿进行其他操作，请勿关闭电脑或浏览器</p>
              </React.Fragment> : importStatus === 3 ? <React.Fragment>
                <i className="iconfont icon-success" />
                <h3>导入成功</h3>
                <Button type="primary" ghost size="small" style={{ marginTop: 5, paddingLeft: 16, paddingRight: 16 }} onClick={this.handleCancel}>完成</Button>
              </React.Fragment> : null
            }
          </div> : null
        }
      </Modal>
    </React.Fragment>
  }
}